<template>
  <div
    class="rank"
    @click="goRank"
  >
    <hgroup class="rank-head">
      <h3>{{ title }} <Icon name="arrow"></Icon>
      </h3>
      <h4>{{ RankingTotal }}</h4>
    </hgroup>
    <ul class="rank-content">
      <template v-for="(item, index) in RankList">
        <li
          v-auth="item.authCode"
          :key="index"
        >
          <span>{{ item.label }}</span>
          <span>{{ item.value }}</span>
        </li>
      </template>

    </ul>
  </div>
</template>
<script>
import { Icon } from 'vant'
export default {
  components: { Icon },
  props: {
    title: {
      type: String,
      default: ''
    },
    total: {
      type: Number,
      default: 0
    },
    dataList: {
      type: Array,
      default: () => []
    },
    rankName: {
      type: String
    }
  },
  watch: {
    total: {
      handler (newVal) {
        this.RankingTotal = newVal
      },
      deep: true
    },
    dataList: {
      handler (newVal) {
        this.RankList = [...newVal]
      },
      deep: true
    }
  },
  methods: {
    goRank () {
      this.$router.push({
        path: '/rank',
        query: {
          'rankName': this.rankName
        }
      })
    }
  },
  data () {
    return {
      RankingTotal: this.total,
      RankList: this.dataList
    }
  }
}
</script>
<style lang="less" scoped>
.rank {
  padding: 0 24px;
  border-radius: 8px;
  background-color: #f0f2f6;

  .rank-head {
    display: block;
    position: relative;
    padding-top: 18px;
    padding-bottom: 10px;

    h3 {
      font-size: 28px;
      font-weight: bold;
      color: #0f0f13;
      line-height: 40px;
    }

    h4 {
      font-family: Arial;
      font-size: 36px;
      font-weight: bold;
      color: #0f0f13;
      line-height:52px;
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 8px;
      border-radius: 39px;
      background: linear-gradient(90deg, #2b65ff 0%, #7fa2ff 100%);
    }
  }

  .rank-content {
    padding-bottom: 14px;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 14px;
      line-height: 40px;
      font-size: 24px;
      color: #5f5f6a;

      span:last-child {
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
}
</style>